export const environment = {
  environment: 'development',
  // Keycloak
  keycloakUrl: 'https://auth.test123.nl',
  keycloakRealm: 'museum-vlaardingen',
  keycloakClientId: 'staging',
  // API
  apiUrl: 'https://mvl-cms-api.test123.nl',
  // apiUrl: 'http://museum-vlaardingen-cms-api.docker:8080'
  // apiUrl: 'https://api-cms.wijkcollectie.nl'
};
